var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrder = function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.5 15.072c0 1.696 1.179 3.261 2.846 3.261h6.946a.63.63 0 0 0 .442-.183l4.166-4.166a.63.63 0 0 0 .183-.442V4.51c0-1.695-1.179-3.261-2.846-3.261H5.346C3.678 1.25 2.5 2.817 2.5 4.52zm2.846 2.011c-.785 0-1.596-.796-1.596-2.01V4.52c0-1.225.813-2.02 1.596-2.02h8.891c.785 0 1.596.797 1.596 2.011v8.772l-.05.05h-3.408a.29.29 0 0 0-.292.292v3.408l-.05.05z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.833 7.5c0-.345.28-.625.625-.625h6.017a.625.625 0 1 1 0 1.25H6.458a.625.625 0 0 1-.625-.625M5.833 11.667c0-.345.28-.625.625-.625h3.334a.625.625 0 0 1 0 1.25H6.458a.625.625 0 0 1-.625-.625",
    clipRule: "evenodd"
  })));
};
export default SvgOrder;